// External Imports
import { useContext, useEffect, useState } from "react";

// Internal Imports
import { AuthContext } from "../../context/auth-context";
import PoshLogo from "../UI/PoshLogo";
import CheckOnline from "../UI/CheckOnline";
import LoadingSpinner from "../UI/LoadingSpinner";
import DataContext from "../../context/data-context";
import { MdHelp, MdLogout } from "react-icons/md";
import { UtilityContext } from "../../context/util-context";

/** ========================================================================
 * * Navbar Component
 * This component renders the navigation bar at the top of the app.
 * ========================================================================== */

export default function Navbar() {
  const { logout } = useContext(AuthContext);
  const { loadingData, partner } = useContext(DataContext);
  const { setIssue, navigate } = useContext(UtilityContext);

  return (
    <header className="z-20">
      <CheckOnline />

      <div className="mx-6 md:mx-12">
        <div
          onClick={() => navigate("/general")}
          className="flex items-center justify-between py-4 cursor-pointer"
        >
          <div
            className="flex items-end justify-start space-x-4"
            data-tour="logo"
          >
            <PoshLogo />
            <p className="text-3xl font-extralight text-stone-400">
              Partner <span className="text-xs">v2.0.1</span>
            </p>
          </div>

          {loadingData ? (
            <LoadingSpinner classes="w-6 h-6 text-white" />
          ) : (
            <div className="flex items-center justify-end flex-1">
              <div className="flex items-center space-x-4">
                {partner?.photo && (
                  <img src={partner.photo} className="w-6 h-6 rounded-full" />
                )}
                {partner && (
                  <p className="hidden text-sm font-semibold text-stone-200 md:block">
                    {partner.type == "business"
                      ? partner.businessName
                      : partner?.name}
                  </p>
                )}

                <div
                  data-tour="issue"
                  onClick={() => setIssue(true)}
                  className="flex items-center md:space-x-2 md:btn-secondary"
                >
                  <p className="hidden text-sm md:block">Report Issue</p>
                  <MdHelp className="icon" />
                </div>
                <div
                  data-tour="logout"
                  onClick={() => logout()}
                  className="flex items-center md:space-x-2 md:btn-secondary"
                >
                  <p className="hidden text-sm md:block">Log Out</p>
                  <MdLogout className="icon" />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
